import React from 'react'
import { colors } from 'src/constants'
import { TSvgIcon } from 'src/types/common.types'

export default function PollIcon({ color = colors.primary[600], ...rest }: TSvgIcon) {
    return (
        <svg fill="#000000" width="22px" height="20px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M 5 5 L 5 27 L 27 27 L 27 5 L 5 5 z M 7 7 L 25 7 L 25 25 L 7 25 L 7 7 z M 15 10 L 15 22 L 17 22 L 17 10 L 15 10 z M 10 14 L 10 22 L 12 22 L 12 14 L 10 14 z M 20 16 L 20 22 L 22 22 L 22 16 L 20 16 z" /></svg>
    )
}
